import { CurrencyIcon } from '@/entities/currency';

import { ICurrencyAccount, NNBSP, ROUTES, cn } from '@/shared/lib';
import { Link, Typography } from '@/shared/ui';
import { Soon } from '@/shared/ui/components/soon';

interface AssetsItemProps {
  account: ICurrencyAccount;
  className?: string;
}
export const AssetsItem = ({ account, className }: AssetsItemProps) => {
  return account.status === 'ACTIVE' ? (
    <Link
      className={cn(
        'flex h-[72px] items-center rounded-[20px] px-4 py-2 !text-base-500 hover:bg-hover-base-500-hover hover:!text-base-500 active:!text-base-500',
        className,
      )}
      to={`${ROUTES.ACCOUNT}?id=${account.id}`}
    >
      <CurrencyIcon ticker={account.code} size="lg" />
      <Typography variant="16-r" className="ml-4">
        {account.currencyName}
      </Typography>

      <Typography variant="16-r" className="ml-auto">
        {`${String(account.value)}${NNBSP}${account.symbol}`}
      </Typography>
    </Link>
  ) : (
    <div
      className={cn(
        'flex h-[72px] items-center justify-between rounded-[20px] px-5 py-2 !text-base-500 hover:bg-hover-base-500-hover hover:!text-base-500 active:!text-base-500',
        className,
      )}
    >
      <div className="flex items-center">
        <CurrencyIcon ticker={account.code} size="lg" />
        <Typography variant="16-r" className="ml-4 text-base-100">
          {account.currencyName}
        </Typography>
      </div>

      <Soon text="Requested" size="sm" />
    </div>
  );
};
